import React from "react";
import {MM_QUESTION} from "../../scripts/myga-model";
import {validateCondition} from "../../scripts/validation";

export default function QuestionSelect(props) {

  const {question, data, handleChange, required, responseClass} = props;
  const responses = question.response[MM_QUESTION.response.constraints];
  const questionDisabled = !validateCondition(question.enableCondition,data);

  return (
    <select id={question.name}
            className={`form-control page-select ${responseClass}`}
            required={required}
            disabled={questionDisabled}
            value={data[question.key]}
            onChange={handleChange(question.key)}>
      <option disabled value={''}>Make a Selection</option>
      {
        responses.map((item, index) => {
          const disabled = !validateCondition(item.enableCondition,data);
          return (
            <option id={`${question.key}-${index}`}
                    key={`${question.key}-${index}`}
                    value={item.value}
                    disabled={disabled}>
              {item.label}
            </option>
          )
        })
      }
    </select>
  )
}